/* eslint max-classes-per-file: 0 */

import {
  PassportTemplate as Data,
  PassportTemplateCollection as Collection,
} from '@/typings/api/Passport'
import { PassportTemplatesApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'

const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PassportTemplatesTransformerParams extends TransformerParams {
}

export class PassportTemplatesAdapter extends Adapter<Api> {
    public readonly api = new Api();

    public readonly transformerParams = new PassportTemplatesTransformerParams();
}
